"use client";

import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";
import { useRef } from "react";
function TestimonialsCarouselConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  const autoplayPlugin = useRef(Autoplay({
    delay: 5000,
    stopOnInteraction: true,
    stopOnMouseEnter: true
  }));
  if (loading) {
    return <div className="mx-auto max-w-4xl px-4">
        <div className="h-64 rounded-lg bg-muted/30 animate-pulse" />
      </div>;
  }
  if (error) {
    return <div className="mx-auto max-w-4xl px-4 text-center">
        <p className="text-sm text-muted-foreground">
          Unable to load testimonials at this time.
        </p>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="mx-auto max-w-4xl px-4 text-center">
        <p className="text-muted-foreground">No testimonials available yet.</p>
      </div>;
  }
  return <Carousel opts={{
    align: "center",
    loop: true
  }} plugins={[autoplayPlugin.current]} className="mx-auto max-w-4xl px-4" onMouseEnter={() => autoplayPlugin.current.stop()} onMouseLeave={() => autoplayPlugin.current.play()}>
      <CarouselContent>
        {posts.map((post, i) => <CarouselItem key={post.id} data-index={i}>
            <div className="flex min-h-[20rem] items-center justify-center p-8">
              <div className="text-center transition-all duration-[250ms] ease-[var(--ease-smooth)]">
                <div className="mb-6 text-lg leading-relaxed text-foreground" dangerouslySetInnerHTML={{
              __html: post.content || ""
            }} />
                {post.author && <div className="space-y-1">
                    <p className="font-display text-base font-semibold text-foreground">
                      {post.author.name}
                    </p>
                    {post.customFields?.role && <p className="text-sm text-muted-foreground">
                        {post.customFields.role}
                      </p>}
                  </div>}
              </div>
            </div>
          </CarouselItem>)}
      </CarouselContent>
      <CarouselPrevious className="left-0 hover-lift focus-ring" />
      <CarouselNext className="right-0 hover-lift focus-ring" />
    </Carousel>;
}
export default function WhatParentsSay() {
  return <section className="bg-background py-16 md:py-24">
      <div className="container mx-auto">
        <h2 className="mb-12 text-center font-display text-3xl font-bold text-foreground md:text-4xl">
          What Parents Say
        </h2>
        <PostsProvider postType="testimonial" className="testimonials-carousel-wrapper" wp_query={{
        per_page: 10,
        order: "desc",
        orderby: "date"
      }} embeds={["author"]} fields={["id", "content.rendered", "_embedded", "_links.author"]}>
          <TestimonialsCarouselConsumer />
        </PostsProvider>
      </div>
    </section>;
}